import React from "react";
import PropTypes from "prop-types";
import { ImageCarousel } from "components/core/ImageCarousel";

const ImagesSection = ({ images }) => (
	<div className="images-section">
		<ImageCarousel images={images} />
	</div>
);

ImagesSection.propTypes = {
	images: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ImagesSection;
